export const NOTIFICATION_OFFSET = "notificationOffset";
export const NOTIFICATION_TYPE = "notificationType";
export const UNREAD = "unread";
export const READ = "read";
